export default {
    antenatalCareTest: 'مراقبتهای قبل زایمان',
    date: 'تاریخ',
    gAByLMPWeek: 'GA Week',
    gAByLMPDay: 'GA Day',
    gABySonographyWeek: 'GA Sonography Week',
    gABySonographyDay: 'GA Sonography Day',
    bP: 'فشار خون',
    description: 'توضیحات',
    fundus: 'Fundus',
    fHR: 'ضربان قلب جنین',
    fM: 'FM',
    oedema: 'Oedema'
}